import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import CarrierCoordination from "@/pages/CarrierCoordination";
import FreightIQ from "@/pages/FreightIQ";
import Workspace from "@/pages/Workspace";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Landing page (SEO focus) */}
          <Route path="/" element={<Navigate to="/carrier-coordination" replace />} />
          <Route path="/carrier-coordination" element={<CarrierCoordination />} />

          {/* Internal product placeholders */}
          <Route path="/freightiq" element={<FreightIQ />} />
          <Route path="/workspace" element={<Workspace />} />
          <Route path="/signup" element={<Workspace />} />

          <Route path="*" element={<Navigate to="/carrier-coordination" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
